import { getCookie } from '../../GlobalComponents/GlobalFunctions'
import { getAPIURL } from '../../GlobalComponents/URLs'
import { getCompanyFromURL } from './../../GlobalComponents/GlobalFunctions'

export interface fetchLogEventPayload {
    EventName: string
    String1?: string
    String2?: string
    String3?: string
    Decimal1?: number
    Decimal2?: number
    Datetime1?: Date
    Datetime2?: Date
    MessageBody?: string
}

export const fetchLogEvent = async (payload: fetchLogEventPayload) => {
    let walkThruCookie = getCookie('WalkThruId')
    let isLoggedIn = !!walkThruCookie

    let url = getAPIURL() + 'master/logevent'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: isLoggedIn
            ? { 'Content-Type': 'application/json' }
            : { 'Content-Type': 'application/json', Company: getCompanyFromURL() },
        body: JSON.stringify(payload),
    })

    if (!(req.ok || req.status === 400)) throw new Error('Failed to log event')
}
